import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    directDebitWarning:
      '**Your direct debit mandate must be updated**\n\n' +
      'This debit was made from your old IBAN.\nFrom {0}, direct debits can no longer be made from this IBAN.\nMake sure to update your IBAN with this organization\n\n' +
      '**See how**',
    payinTransferWarning:
      '**This transfer was sent to your old IBAN**\n\n' +
      'From {0}, you will no longer be able to receive transfers to this IBAN. We recommend that you contact the issuer to send them your new bank details.\n\n' +
      '**Show my new details**',
  },
  fr: {
    directDebitWarning:
      '**Votre mandat de prélèvement doit être mis à jour**\n\n' +
      'Ce prélèvement a été effectué sur votre ancien IBAN.\nÀ partir du {0} les prélèvements sur cet IBAN ne pourront plus avoir lieu.\nVeillez à modifier votre IBAN auprès de cet organisme\n\n' +
      '**Voir comment faire**',
    payinTransferWarning:
      '**Ce virement a été envoyé sur votre ancien IBAN**\n\n' +
      'À partir du {0}, vous ne pourrez plus recevoir de virements sur cet IBAN. Nous vous recommandons de contacter l’émetteur·ice afin de lui transmettre votre nouveau RIB.\n\n' +
      '**Afficher mon nouveau RIB**',
  },
});

export default locales;
